"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexBy = void 0;
var arrayToObject_1 = require("./arrayToObject");
function indexBy(arr, keyFn) {
    if (typeof keyFn !== 'function') {
        var key_1 = keyFn;
        // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-base-to-string
        keyFn = (function (value) { return value[key_1].toString(); });
    }
    return arrayToObject_1.arrayToObject(arr, function (val) {
        var _a;
        return (_a = {}, _a[keyFn(val)] = val, _a);
    });
}
exports.indexBy = indexBy;
//# sourceMappingURL=indexBy.js.map